var path = 'src/app/ui/sort-helper.html';
var html = "<a href=\"\" ng-click=sort()><span ng-transclude></span></a> <i class=\"fa fa-sort-asc\" ng-show=isAscending()></i> <i class=\"fa fa-sort-desc\" ng-show=isDescending()></i> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/ui/sort-helper.html
// module id = 669
// module chunks = 0